/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Agent from './Agent';
import InvestmentProposalAttachmentFile from './InvestmentProposalAttachmentFile';
import InvestmentProposalHistory from './InvestmentProposalHistory';
import OfferScore from './OfferScore';
import ProposalDeliveryStatus from './ProposalDeliveryStatus';
import ProposalStatusEnum from './ProposalStatusEnum';
import User from './User';

/**
 * The InvestmentProposal model module.
 * @module model/InvestmentProposal
 * @version 1.0.0
 */
class InvestmentProposal {
    /**
     * Constructs a new <code>InvestmentProposal</code>.
     * @alias module:model/InvestmentProposal
     */
    constructor() { 
        
        InvestmentProposal.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentProposal</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentProposal} obj Optional instance to populate.
     * @return {module:model/InvestmentProposal} The populated <code>InvestmentProposal</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentProposal();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('is_user_read')) {
                obj['is_user_read'] = ApiClient.convertToType(data['is_user_read'], 'Boolean');
            }
            if (data.hasOwnProperty('is_user_approved')) {
                obj['is_user_approved'] = ApiClient.convertToType(data['is_user_approved'], 'Boolean');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('user_read_at')) {
                obj['user_read_at'] = ApiClient.convertToType(data['user_read_at'], 'Date');
            }
            if (data.hasOwnProperty('user_approved_at')) {
                obj['user_approved_at'] = ApiClient.convertToType(data['user_approved_at'], 'Date');
            }
            if (data.hasOwnProperty('user_registered_at')) {
                obj['user_registered_at'] = ApiClient.convertToType(data['user_registered_at'], 'Date');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('discarded_at')) {
                obj['discarded_at'] = ApiClient.convertToType(data['discarded_at'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ProposalDeliveryStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('failure_reason')) {
                obj['failure_reason'] = ApiClient.convertToType(data['failure_reason'], 'String');
            }
            if (data.hasOwnProperty('first_preferred_contact_date')) {
                obj['first_preferred_contact_date'] = ApiClient.convertToType(data['first_preferred_contact_date'], 'Date');
            }
            if (data.hasOwnProperty('first_preferred_contact_time_slot')) {
                obj['first_preferred_contact_time_slot'] = ApiClient.convertToType(data['first_preferred_contact_time_slot'], 'String');
            }
            if (data.hasOwnProperty('second_preferred_contact_date')) {
                obj['second_preferred_contact_date'] = ApiClient.convertToType(data['second_preferred_contact_date'], 'Date');
            }
            if (data.hasOwnProperty('second_preferred_contact_time_slot')) {
                obj['second_preferred_contact_time_slot'] = ApiClient.convertToType(data['second_preferred_contact_time_slot'], 'String');
            }
            if (data.hasOwnProperty('agent')) {
                obj['agent'] = Agent.constructFromObject(data['agent']);
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = User.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('investment_proposal_attachment_files')) {
                obj['investment_proposal_attachment_files'] = ApiClient.convertToType(data['investment_proposal_attachment_files'], [InvestmentProposalAttachmentFile]);
            }
            if (data.hasOwnProperty('proposal_status')) {
                obj['proposal_status'] = ProposalStatusEnum.constructFromObject(data['proposal_status']);
            }
            if (data.hasOwnProperty('is_matched')) {
                obj['is_matched'] = ApiClient.convertToType(data['is_matched'], 'Boolean');
            }
            if (data.hasOwnProperty('is_matchable')) {
                obj['is_matchable'] = ApiClient.convertToType(data['is_matchable'], 'Boolean');
            }
            if (data.hasOwnProperty('has_matched')) {
                obj['has_matched'] = ApiClient.convertToType(data['has_matched'], 'Boolean');
            }
            if (data.hasOwnProperty('history_investment_proposals')) {
                obj['history_investment_proposals'] = ApiClient.convertToType(data['history_investment_proposals'], [InvestmentProposalHistory]);
            }
            if (data.hasOwnProperty('offer_score')) {
                obj['offer_score'] = OfferScore.constructFromObject(data['offer_score']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentProposal</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentProposal</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['failure_reason'] && !(typeof data['failure_reason'] === 'string' || data['failure_reason'] instanceof String)) {
            throw new Error("Expected the field `failure_reason` to be a primitive type in the JSON string but got " + data['failure_reason']);
        }
        // ensure the json data is a string
        if (data['first_preferred_contact_time_slot'] && !(typeof data['first_preferred_contact_time_slot'] === 'string' || data['first_preferred_contact_time_slot'] instanceof String)) {
            throw new Error("Expected the field `first_preferred_contact_time_slot` to be a primitive type in the JSON string but got " + data['first_preferred_contact_time_slot']);
        }
        // ensure the json data is a string
        if (data['second_preferred_contact_time_slot'] && !(typeof data['second_preferred_contact_time_slot'] === 'string' || data['second_preferred_contact_time_slot'] instanceof String)) {
            throw new Error("Expected the field `second_preferred_contact_time_slot` to be a primitive type in the JSON string but got " + data['second_preferred_contact_time_slot']);
        }
        // validate the optional field `agent`
        if (data['agent']) { // data not null
          Agent.validateJSON(data['agent']);
        }
        // validate the optional field `user`
        if (data['user']) { // data not null
          User.validateJSON(data['user']);
        }
        if (data['investment_proposal_attachment_files']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['investment_proposal_attachment_files'])) {
                throw new Error("Expected the field `investment_proposal_attachment_files` to be an array in the JSON data but got " + data['investment_proposal_attachment_files']);
            }
            // validate the optional field `investment_proposal_attachment_files` (array)
            for (const item of data['investment_proposal_attachment_files']) {
                InvestmentProposalAttachmentFile.validateJSON(item);
            };
        }
        if (data['history_investment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['history_investment_proposals'])) {
                throw new Error("Expected the field `history_investment_proposals` to be an array in the JSON data but got " + data['history_investment_proposals']);
            }
            // validate the optional field `history_investment_proposals` (array)
            for (const item of data['history_investment_proposals']) {
                InvestmentProposalHistory.validateJSON(item);
            };
        }
        // validate the optional field `offer_score`
        if (data['offer_score']) { // data not null
          OfferScore.validateJSON(data['offer_score']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
InvestmentProposal.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
InvestmentProposal.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
InvestmentProposal.prototype['user_id'] = undefined;

/**
 * @member {String} proposal_content
 */
InvestmentProposal.prototype['proposal_content'] = undefined;

/**
 * @member {Boolean} is_user_read
 */
InvestmentProposal.prototype['is_user_read'] = undefined;

/**
 * @member {Boolean} is_user_approved
 */
InvestmentProposal.prototype['is_user_approved'] = undefined;

/**
 * status=scheduled の場合は予約送信予定日時、status=sent の場合は実送信日時
 * @member {Date} proposal_date
 */
InvestmentProposal.prototype['proposal_date'] = undefined;

/**
 * @member {Date} created_at
 */
InvestmentProposal.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
InvestmentProposal.prototype['updated_at'] = undefined;

/**
 * @member {Date} user_read_at
 */
InvestmentProposal.prototype['user_read_at'] = undefined;

/**
 * @member {Date} user_approved_at
 */
InvestmentProposal.prototype['user_approved_at'] = undefined;

/**
 * @member {Date} user_registered_at
 */
InvestmentProposal.prototype['user_registered_at'] = undefined;

/**
 * @member {String} short_appeal_message
 */
InvestmentProposal.prototype['short_appeal_message'] = undefined;

/**
 * @member {Date} discarded_at
 */
InvestmentProposal.prototype['discarded_at'] = undefined;

/**
 * @member {module:model/ProposalDeliveryStatus} status
 */
InvestmentProposal.prototype['status'] = undefined;

/**
 * 送信失敗理由。例 daily_offer_limit, user_withdrawn, agent_access_blocked
 * @member {String} failure_reason
 */
InvestmentProposal.prototype['failure_reason'] = undefined;

/**
 * 第一希望日
 * @member {Date} first_preferred_contact_date
 */
InvestmentProposal.prototype['first_preferred_contact_date'] = undefined;

/**
 * 第一希望時間帯
 * @member {module:model/InvestmentProposal.FirstPreferredContactTimeSlotEnum} first_preferred_contact_time_slot
 */
InvestmentProposal.prototype['first_preferred_contact_time_slot'] = undefined;

/**
 * 第二希望日
 * @member {Date} second_preferred_contact_date
 */
InvestmentProposal.prototype['second_preferred_contact_date'] = undefined;

/**
 * 第二希望時間帯
 * @member {module:model/InvestmentProposal.SecondPreferredContactTimeSlotEnum} second_preferred_contact_time_slot
 */
InvestmentProposal.prototype['second_preferred_contact_time_slot'] = undefined;

/**
 * @member {module:model/Agent} agent
 */
InvestmentProposal.prototype['agent'] = undefined;

/**
 * @member {module:model/User} user
 */
InvestmentProposal.prototype['user'] = undefined;

/**
 * @member {Array.<module:model/InvestmentProposalAttachmentFile>} investment_proposal_attachment_files
 */
InvestmentProposal.prototype['investment_proposal_attachment_files'] = undefined;

/**
 * @member {module:model/ProposalStatusEnum} proposal_status
 */
InvestmentProposal.prototype['proposal_status'] = undefined;

/**
 * 本提案がマッチしているかどうか
 * @member {Boolean} is_matched
 */
InvestmentProposal.prototype['is_matched'] = undefined;

/**
 * ユーザーが本提案をマッチ（承認）可能かどうか
 * @member {Boolean} is_matchable
 */
InvestmentProposal.prototype['is_matchable'] = undefined;

/**
 * 全提案、手動ユーザ提案含め、ユーザとエージェントでのマッチが存在するかどうか
 * @member {Boolean} has_matched
 */
InvestmentProposal.prototype['has_matched'] = undefined;

/**
 * 必要に応じて、ユーザーと該当エージェント間の提案履歴を返す
 * @member {Array.<module:model/InvestmentProposalHistory>} history_investment_proposals
 */
InvestmentProposal.prototype['history_investment_proposals'] = undefined;

/**
 * @member {module:model/OfferScore} offer_score
 */
InvestmentProposal.prototype['offer_score'] = undefined;





/**
 * Allowed values for the <code>first_preferred_contact_time_slot</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentProposal['FirstPreferredContactTimeSlotEnum'] = {

    /**
     * value: "morning"
     * @const
     */
    "morning": "morning",

    /**
     * value: "afternoon"
     * @const
     */
    "afternoon": "afternoon",

    /**
     * value: "evening"
     * @const
     */
    "evening": "evening",

    /**
     * value: "slot_9_11"
     * @const
     */
    "slot_9_11": "slot_9_11",

    /**
     * value: "slot_11_13"
     * @const
     */
    "slot_11_13": "slot_11_13",

    /**
     * value: "slot_13_15"
     * @const
     */
    "slot_13_15": "slot_13_15",

    /**
     * value: "slot_15_17"
     * @const
     */
    "slot_15_17": "slot_15_17",

    /**
     * value: "slot_17_19"
     * @const
     */
    "slot_17_19": "slot_17_19",

    /**
     * value: "slot_19_21"
     * @const
     */
    "slot_19_21": "slot_19_21"
};


/**
 * Allowed values for the <code>second_preferred_contact_time_slot</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentProposal['SecondPreferredContactTimeSlotEnum'] = {

    /**
     * value: "morning"
     * @const
     */
    "morning": "morning",

    /**
     * value: "afternoon"
     * @const
     */
    "afternoon": "afternoon",

    /**
     * value: "evening"
     * @const
     */
    "evening": "evening",

    /**
     * value: "slot_9_11"
     * @const
     */
    "slot_9_11": "slot_9_11",

    /**
     * value: "slot_11_13"
     * @const
     */
    "slot_11_13": "slot_11_13",

    /**
     * value: "slot_13_15"
     * @const
     */
    "slot_13_15": "slot_13_15",

    /**
     * value: "slot_15_17"
     * @const
     */
    "slot_15_17": "slot_15_17",

    /**
     * value: "slot_17_19"
     * @const
     */
    "slot_17_19": "slot_17_19",

    /**
     * value: "slot_19_21"
     * @const
     */
    "slot_19_21": "slot_19_21"
};



export default InvestmentProposal;

